import React from "react";
import { Crown } from "lucide-react";

/**
 * PlusBadge — tiny "Studio Plus" pill shown next to a member's name. Accepts
 * a `tier` string (or a `user` object with .tier) and renders nothing unless
 * the tier is "studio_plus". Two visual sizes: "sm" for inline use, "xs" for
 * dense author lines.
 */
export default function PlusBadge({ user, tier: tierProp, size = "sm" }) {
  const tier = tierProp || user?.tier;
  if (tier !== "studio_plus") return null;
  const sizeClass =
    size === "xs"
      ? "text-[9px] px-1.5 py-[1px] gap-0.5"
      : "text-[10px] px-1.5 py-0.5 gap-1";
  return (
    <span
      data-testid="studio-plus-badge"
      title="Studio Plus member"
      className={`inline-flex items-center font-extrabold uppercase tracking-[0.14em] rounded-md bg-paul-yellow text-navy ${sizeClass}`}
      style={{ color: "#0b1535" }}
    >
      <Crown className={size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3"} />
      Plus
    </span>
  );
}
